import { GetEntityListMetadataAction } from './GetEntityListMetadataAction';
import { GetEntityListMetadataSuccessAction } from './GetEntityListMetadataSuccessAction';
import { ReviseRootEntityAction } from './ReviseRootEntityAction';
import { ReviseRootEntityResponseAction } from './ReviseRootEntityResponseAction';
import { AddWorkspaceAction } from './AddWorkspaceAction';
import { SubmittingEntitySelectedAction } from './SubmittingEntitySelectedAction';
import { CloneWorkspaceAction } from './CloneWorkspaceAction';
import { SyncWithNextgateAction } from './SyncWithNextgateAction';
import { SyncWithNextgateResponseAction } from './SyncWithNextgateResponseAction';

export type EntityActions = GetEntityListMetadataAction |
                      GetEntityListMetadataSuccessAction |
                      ReviseRootEntityAction |
                      ReviseRootEntityResponseAction |
                      AddWorkspaceAction |
                      CloneWorkspaceAction;

export type Actions = GetEntityListMetadataAction |
                      GetEntityListMetadataSuccessAction |
                      ReviseRootEntityAction |
                      ReviseRootEntityResponseAction |
                      AddWorkspaceAction |
                      CloneWorkspaceAction |
                      SubmittingEntitySelectedAction |
                      SyncWithNextgateAction |
                      SyncWithNextgateResponseAction;

export * from './GetEntityListMetadataAction';
export * from './GetEntityListMetadataSuccessAction';
export * from './ReviseRootEntityAction';
export * from './ReviseRootEntityResponseAction';
export * from './AddWorkspaceAction';
export * from './SubmittingEntitySelectedAction';
export * from './CloneWorkspaceAction';
export * from './SyncWithNextgateAction';
export * from './SyncWithNextgateResponseAction';


// WEBPACK FOOTER //
// ./src/app/datawarehouse/store/actions/index.ts